import StickySidebar from "sticky-sidebar";

const defaultOptions = {
    tabHeadingSelector: '.js-toggle-tab',
    tabSelector: '.js-tab',
    activeTabHeadingClass: 'tab-heading--active',
    activeTabClass: 'tab-content--active',
};

export default class TabbedContent {
    constructor(root, options) {
        this.root = root;
        this.options = Object.assign({}, defaultOptions, options);


        this.tabHeadings = Array.from(this.root.querySelectorAll(this.options.tabHeadingSelector));
        this.mobileSelect = this.root.querySelector('.js-mobile-select');
        this.tabs = Array.from(this.root.querySelectorAll(this.options.tabSelector));
        this.navigationContainer = this.root.querySelector('.tabbed-content__navigation');
        this.tabContainer = this.root.querySelector('.tabbed-content__content-container');

        this.setupControlsEvents();
        this.resetStickyNavigation();
        this.setTabContainerHeight();
    }

    setupControlsEvents() {
        this.tabHeadings.forEach(tabHeading => {
            tabHeading.addEventListener('click', e => {
                e.preventDefault();

                let tabId = tabHeading.dataset.tab;

                this.root.querySelector('.' + this.options.activeTabHeadingClass).classList.remove(this.options.activeTabHeadingClass);
                tabHeading.classList.add(this.options.activeTabHeadingClass);

                this.hideActiveTab();
                this.showTab(tabId);
            });
        });

        this.mobileSelect.addEventListener('change', e => {
            let tabId = e.target.value;
            this.hideActiveTab();
            this.showTab(tabId);
        });
    }

    setTabContainerHeight() {
        let activeTab = this.getActiveTab();
        this.tabContainer.style.height = activeTab.clientHeight + 'px';
        this.resetStickyNavigation();
    }

    hideActiveTab() {
        let activeTab = this.getActiveTab();
        activeTab.classList.remove(this.options.activeTabClass);
    }

    showTab(tabId) {
        this.root.querySelector(tabId).classList.add(this.options.activeTabClass);
        this.setTabContainerHeight();

        window.scrollTo({
            top: this.tabContainer.getBoundingClientRect().top + window.scrollY - 100
        });
    }

    getActiveTab() {
        return this.root.querySelector('.' + this.options.activeTabClass);
    }

    resetStickyNavigation() {
        if (window.innerWidth > 600) {
            if (this.stickyNavigation) {
                this.stickyNavigation.destroy();
            }

            this.stickyNavigation = new StickySidebar(this.navigationContainer, {
                contentContainer: '.tabbed-content__content-container',
                topSpacing: 100,
                resizeSensor: false,
            });
        } else {

        }
    }
}
